import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CookiesPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-6">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Volver a inicio
        </Link>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Política de Cookies</h1>
        
        <div className="prose prose-gray max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. ¿Qué son las cookies?</h2>
            <p className="text-gray-600">
              Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita un sitio web. Se utilizan para hacer que los sitios web funcionen de manera más eficiente y para proporcionar información a los propietarios del sitio.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Responsable del uso de cookies</h2>
            <p className="text-gray-600">
              <strong>Identidad:</strong> Eye Star S.L.<br />
              <strong>CIF:</strong> B87171740<br />
              <strong>Dirección:</strong> Avenida de la Industria 16, Tres Cantos (Madrid)<br />
              <strong>Email:</strong> reservas@hotel-martorell.es
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Tipos de cookies que utilizamos</h2>
            
            <h3 className="text-lg font-medium text-gray-700 mt-4 mb-2">Cookies técnicas (necesarias)</h3>
            <p className="text-gray-600">
              Son imprescindibles para el funcionamiento del sitio web. Permiten la navegación y el uso de las diferentes opciones y servicios.
            </p>
            
            <h3 className="text-lg font-medium text-gray-700 mt-4 mb-2">Cookies de preferencias</h3>
            <p className="text-gray-600">
              Permiten recordar información para que el usuario acceda al servicio con determinadas características (idioma, configuración regional, etc.).
            </p>
            
            <h3 className="text-lg font-medium text-gray-700 mt-4 mb-2">Cookies analíticas</h3>
            <p className="text-gray-600">
              Permiten el seguimiento y análisis del comportamiento de los usuarios. La información recogida se utiliza para medir la actividad del sitio web y elaborar perfiles de navegación.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Cookies utilizadas en este sitio</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200 mt-3">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border-b">Nombre</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border-b">Tipo</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border-b">Duración</th>
                    <th className="px-4 py-2 text-left text-sm font-medium text-gray-700 border-b">Finalidad</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">cookies_accepted</td>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">Técnica</td>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">1 año</td>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">Recordar preferencias de cookies</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">token</td>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">Técnica</td>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">24 horas</td>
                    <td className="px-4 py-2 text-sm text-gray-600 border-b">Mantener sesión de usuario</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Cómo gestionar las cookies</h2>
            <p className="text-gray-600">
              Puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones de su navegador:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2 mt-2">
              <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Google Chrome</a></li>
              <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Mozilla Firefox</a></li>
              <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Safari</a></li>
              <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">Microsoft Edge</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Actualización de la política</h2>
            <p className="text-gray-600">
              Esta política de cookies puede ser actualizada en función de exigencias legales o con la finalidad de adaptar dicha política a las instrucciones de la Agencia Española de Protección de Datos.
            </p>
          </section>
        </div>

        <p className="text-sm text-gray-500 mt-8">
          Última actualización: Febrero 2026
        </p>
      </div>
    </div>
  );
};

export default CookiesPolicy;
